// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file bffuser/v1/plan_auto_resubmit_setting_service.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { AreaCode } from "../../bfftypes/v1/area_pb";
import { file_bfftypes_v1_area } from "../../bfftypes/v1/area_pb";
import type { ProcurementPlanAutoResubmitCategory } from "../../bfftypes/v1/procurement_plan_auto_resubmit_category_pb";
import { file_bfftypes_v1_procurement_plan_auto_resubmit_category } from "../../bfftypes/v1/procurement_plan_auto_resubmit_category_pb";
import type { ProcurementPlanAutoResubmitSetting } from "./plan_auto_resubmit_setting_model_pb";
import { file_bffuser_v1_plan_auto_resubmit_setting_model } from "./plan_auto_resubmit_setting_model_pb";
import { file_buf_validate_validate } from "../../buf/validate/validate_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file bffuser/v1/plan_auto_resubmit_setting_service.proto.
 */
export const file_bffuser_v1_plan_auto_resubmit_setting_service: GenFile = /*@__PURE__*/
  fileDesc("CjNiZmZ1c2VyL3YxL3BsYW5fYXV0b19yZXN1Ym1pdF9zZXR0aW5nX3NlcnZpY2UucHJvdG8SCmJmZnVzZXIudjEiKAomR2V0UGxhbkF1dG9SZXN1Ym1pdEF2YWlsYWJpbGl0eVJlcXVlc3QiQgonR2V0UGxhbkF1dG9SZXN1Ym1pdEF2YWlsYWJpbGl0eVJlc3BvbnNlEhcKD2ZlYXR1cmVfZW5hYmxlZBgBIAEoCCIwCi5MaXN0UHJvY3VyZW1lbnRQbGFuQXV0b1Jlc3VibWl0U2V0dGluZ3NSZXF1ZXN0IowBCi9MaXN0UHJvY3VyZW1lbnRQbGFuQXV0b1Jlc3VibWl0U2V0dGluZ3NSZXNwb25zZRJACghzZXR0aW5ncxgBIAMoCzIuLmJmZnVzZXIudjEuUHJvY3VyZW1lbnRQbGFuQXV0b1Jlc3VibWl0U2V0dGluZxIXCg9mZWF0dXJlX2VuYWJsZWQYAiABKAgingIKL1VwZGF0ZVByb2N1cmVtZW50UGxhbkF1dG9SZXN1Ym1pdFNldHRpbmdSZXF1ZXN0EjQKCWFyZWFfY29kZRgBIAEoDjIVLmJmZnR5cGVzLnYxLkFyZWFDb2RlQgq6SAeCAQQQASAAEk4KCGNhdGVnb3J5GAIgASgOMjAuYmZmdHlwZXMudjEuUHJvY3VyZW1lbnRQbGFuQXV0b1Jlc3VibWl0Q2F0ZWdvcnlCCrpIB4IBBBABIAASDwoHZW5hYmxlZBgDIAEoCBI8ChNleHBlY3RlZF91cGRhdGVkX2F0GAQgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcEgAiAEBQhYKFF9leHBlY3RlZF91cGRhdGVkX2F0InMKMFVwZGF0ZVByb2N1cmVtZW50UGxhbkF1dG9SZXN1Ym1pdFNldHRpbmdSZXNwb25zZRI/CgdzZXR0aW5nGAEgASgLMi4uYmZmdXNlci52MS5Qcm9jdXJlbWVudFBsYW5BdXRvUmVzdWJtaXRTZXR0aW5nMoAECh5QbGFuQXV0b1Jlc3VibWl0U2V0dGluZ1NlcnZpY2USjAEKH0dldFBsYW5BdXRvUmVzdWJtaXRBdmFpbGFiaWxpdHkSMi5iZmZ1c2VyLnYxLkdldFBsYW5BdXRvUmVzdWJtaXRBdmFpbGFiaWxpdHlSZXF1ZXN0GjMuYmZmdXNlci52MS5HZXRQbGFuQXV0b1Jlc3VibWl0QXZhaWxhYmlsaXR5UmVzcG9uc2UiABKkAQonTGlzdFByb2N1cmVtZW50UGxhbkF1dG9SZXN1Ym1pdFNldHRpbmdzEjouYmZmdXNlci52MS5MaXN0UHJvY3VyZW1lbnRQbGFuQXV0b1Jlc3VibWl0U2V0dGluZ3NSZXF1ZXN0GjsuYmZmdXNlci52MS5MaXN0UHJvY3VyZW1lbnRQbGFuQXV0b1Jlc3VibWl0U2V0dGluZ3NSZXNwb25zZSIAEqcBCihVcGRhdGVQcm9jdXJlbWVudFBsYW5BdXRvUmVzdWJtaXRTZXR0aW5nEjsuYmZmdXNlci52MS5VcGRhdGVQcm9jdXJlbWVudFBsYW5BdXRvUmVzdWJtaXRTZXR0aW5nUmVxdWVzdBo8LmJmZnVzZXIudjEuVXBkYXRlUHJvY3VyZW1lbnRQbGFuQXV0b1Jlc3VibWl0U2V0dGluZ1Jlc3BvbnNlIgBCQFo+Z2l0aHViLmNvbS9lbmVjaGFpbi9lYmFsYW5jZS9nby9nZW4vcHJvdG8vYmZmdXNlci92MTtiZmZ1c2VydjFiBnByb3RvMw", [file_bfftypes_v1_area, file_bfftypes_v1_procurement_plan_auto_resubmit_category, file_bffuser_v1_plan_auto_resubmit_setting_model, file_buf_validate_validate, file_google_protobuf_timestamp]);

/**
 * @generated from message bffuser.v1.GetPlanAutoResubmitAvailabilityRequest
 */
export type GetPlanAutoResubmitAvailabilityRequest = Message<"bffuser.v1.GetPlanAutoResubmitAvailabilityRequest"> & {
};

/**
 * Describes the message bffuser.v1.GetPlanAutoResubmitAvailabilityRequest.
 * Use `create(GetPlanAutoResubmitAvailabilityRequestSchema)` to create a new message.
 */
export const GetPlanAutoResubmitAvailabilityRequestSchema: GenMessage<GetPlanAutoResubmitAvailabilityRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_plan_auto_resubmit_setting_service, 0);

/**
 * @generated from message bffuser.v1.GetPlanAutoResubmitAvailabilityResponse
 */
export type GetPlanAutoResubmitAvailabilityResponse = Message<"bffuser.v1.GetPlanAutoResubmitAvailabilityResponse"> & {
  /**
   * Whether the settings are available (the same for every organization).
   *
   * @generated from field: bool feature_enabled = 1;
   */
  featureEnabled: boolean;
};

/**
 * Describes the message bffuser.v1.GetPlanAutoResubmitAvailabilityResponse.
 * Use `create(GetPlanAutoResubmitAvailabilityResponseSchema)` to create a new message.
 */
export const GetPlanAutoResubmitAvailabilityResponseSchema: GenMessage<GetPlanAutoResubmitAvailabilityResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_plan_auto_resubmit_setting_service, 1);

/**
 * @generated from message bffuser.v1.ListProcurementPlanAutoResubmitSettingsRequest
 */
export type ListProcurementPlanAutoResubmitSettingsRequest = Message<"bffuser.v1.ListProcurementPlanAutoResubmitSettingsRequest"> & {
};

/**
 * Describes the message bffuser.v1.ListProcurementPlanAutoResubmitSettingsRequest.
 * Use `create(ListProcurementPlanAutoResubmitSettingsRequestSchema)` to create a new message.
 */
export const ListProcurementPlanAutoResubmitSettingsRequestSchema: GenMessage<ListProcurementPlanAutoResubmitSettingsRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_plan_auto_resubmit_setting_service, 2);

/**
 * @generated from message bffuser.v1.ListProcurementPlanAutoResubmitSettingsResponse
 */
export type ListProcurementPlanAutoResubmitSettingsResponse = Message<"bffuser.v1.ListProcurementPlanAutoResubmitSettingsResponse"> & {
  /**
   * Always 20 units in a fixed order (see the RPC comment) when
   * feature_enabled is true; empty when it is false.
   *
   * @generated from field: repeated bffuser.v1.ProcurementPlanAutoResubmitSetting settings = 1;
   */
  settings: ProcurementPlanAutoResubmitSetting[];

  /**
   * Whether the settings are available (the same for every organization).
   *
   * @generated from field: bool feature_enabled = 2;
   */
  featureEnabled: boolean;
};

/**
 * Describes the message bffuser.v1.ListProcurementPlanAutoResubmitSettingsResponse.
 * Use `create(ListProcurementPlanAutoResubmitSettingsResponseSchema)` to create a new message.
 */
export const ListProcurementPlanAutoResubmitSettingsResponseSchema: GenMessage<ListProcurementPlanAutoResubmitSettingsResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_plan_auto_resubmit_setting_service, 3);

/**
 * @generated from message bffuser.v1.UpdateProcurementPlanAutoResubmitSettingRequest
 */
export type UpdateProcurementPlanAutoResubmitSettingRequest = Message<"bffuser.v1.UpdateProcurementPlanAutoResubmitSettingRequest"> & {
  /**
   * @generated from field: bfftypes.v1.AreaCode area_code = 1;
   */
  areaCode: AreaCode;

  /**
   * @generated from field: bfftypes.v1.ProcurementPlanAutoResubmitCategory category = 2;
   */
  category: ProcurementPlanAutoResubmitCategory;

  /**
   * New on/off of the unit.
   *
   * @generated from field: bool enabled = 3;
   */
  enabled: boolean;

  /**
   * Optimistic-lock baseline: the updated_at returned for the unit by List
   * or by the previous Update. Absent when the unit has never been saved.
   *
   * @generated from field: optional google.protobuf.Timestamp expected_updated_at = 4;
   */
  expectedUpdatedAt?: Timestamp;
};

/**
 * Describes the message bffuser.v1.UpdateProcurementPlanAutoResubmitSettingRequest.
 * Use `create(UpdateProcurementPlanAutoResubmitSettingRequestSchema)` to create a new message.
 */
export const UpdateProcurementPlanAutoResubmitSettingRequestSchema: GenMessage<UpdateProcurementPlanAutoResubmitSettingRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_plan_auto_resubmit_setting_service, 4);

/**
 * @generated from message bffuser.v1.UpdateProcurementPlanAutoResubmitSettingResponse
 */
export type UpdateProcurementPlanAutoResubmitSettingResponse = Message<"bffuser.v1.UpdateProcurementPlanAutoResubmitSettingResponse"> & {
  /**
   * The saved unit. updated_at is the baseline for the next update of the
   * same unit.
   *
   * @generated from field: bffuser.v1.ProcurementPlanAutoResubmitSetting setting = 1;
   */
  setting?: ProcurementPlanAutoResubmitSetting;
};

/**
 * Describes the message bffuser.v1.UpdateProcurementPlanAutoResubmitSettingResponse.
 * Use `create(UpdateProcurementPlanAutoResubmitSettingResponseSchema)` to create a new message.
 */
export const UpdateProcurementPlanAutoResubmitSettingResponseSchema: GenMessage<UpdateProcurementPlanAutoResubmitSettingResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_plan_auto_resubmit_setting_service, 5);

/**
 * PlanAutoResubmitSettingService lets users view and edit the automatic plan
 * resubmission settings (plan-auto-resubmit.md §1). Every user of the plan
 * list may view and edit them; there is no role-based gating (AC-PAR-010).
 * organization_id and the updater are resolved by the BFF handler from eauth.
 * The settings are released to every organization at once by a feature flag;
 * while it is off no setting is returned or written.
 *
 * @generated from service bffuser.v1.PlanAutoResubmitSettingService
 */
export const PlanAutoResubmitSettingService: GenService<{
  /**
   * GetPlanAutoResubmitAvailability returns whether the automatic plan
   * resubmission settings are available (the same for every organization). The
   * plan list shows the settings entry only when feature_enabled is true.
   *
   * @generated from rpc bffuser.v1.PlanAutoResubmitSettingService.GetPlanAutoResubmitAvailability
   */
  getPlanAutoResubmitAvailability: {
    methodKind: "unary";
    input: typeof GetPlanAutoResubmitAvailabilityRequestSchema;
    output: typeof GetPlanAutoResubmitAvailabilityResponseSchema;
  },
  /**
   * ListProcurementPlanAutoResubmitSettings returns all 20 需要調達計画
   * setting units (10 areas × 2 区分) in AreaCode order, then 需要BG before
   * 自己託送BG. Units with no saved row are returned as enabled=false
   * without updated_at (AC-PAR-001 既定はオフ). feature_enabled=false and no
   * settings when the settings are not available.
   *
   * @generated from rpc bffuser.v1.PlanAutoResubmitSettingService.ListProcurementPlanAutoResubmitSettings
   */
  listProcurementPlanAutoResubmitSettings: {
    methodKind: "unary";
    input: typeof ListProcurementPlanAutoResubmitSettingsRequestSchema;
    output: typeof ListProcurementPlanAutoResubmitSettingsResponseSchema;
  },
  /**
   * UpdateProcurementPlanAutoResubmitSetting saves the on/off of one setting
   * unit (AC-PAR-002 / 011). When another user changed the unit first
   * (expected_updated_at does not match), the server returns ABORTED and
   * keeps the stored value. FAILED_PRECONDITION (nothing is written) when the
   * settings are not available.
   *
   * @generated from rpc bffuser.v1.PlanAutoResubmitSettingService.UpdateProcurementPlanAutoResubmitSetting
   */
  updateProcurementPlanAutoResubmitSetting: {
    methodKind: "unary";
    input: typeof UpdateProcurementPlanAutoResubmitSettingRequestSchema;
    output: typeof UpdateProcurementPlanAutoResubmitSettingResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_bffuser_v1_plan_auto_resubmit_setting_service, 0);

